export interface RoomDto {
  id: string
  date_created: Date
  date_modified: Date
  active_participants: string[]
  conversation_id: string
  status: RoomStatusDto
  room_source: RoomSourceDto
  sessions: RoomSessionDto[]
}

export enum RoomStatusDto {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
}

export type RoomSourceDto = WherebyRoomSourceDto | LocalRoomSourceDto

export interface WherebyRoomSourceDto {
  type: 'Whereby'
  room_source_id: string
  room_name: string
}

export interface LocalRoomSourceDto {
  type: 'Local'
  room_source_id: string
}

export interface RoomSessionDto {
  id: string
  date_started: Date
  date_modified: Date
  participants: RoomSessionParticipantDto[]
  status: RoomSessionStatusDto
}

export enum RoomSessionStatusDto {
  Active = 'ACTIVE',
  Ended = 'ENDED',
}

export interface RoomSessionParticipantDto {
  user_public_id: string
  status: RoomSessionParticipantStatusDto
  date_connected: Date
  date_disconnected: Date
}

export enum RoomSessionParticipantStatusDto {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
}

export type RoomConnectionDescriptorDto =
  | WherebyRoomConnectionDescriptorDto
  | LocalRoomConnectionDescriptorDto

export interface LocalRoomConnectionDescriptorDto {
  type: 'Local'
}

export interface WherebyRoomConnectionDescriptorDto {
  type: 'Whereby'
  room_url: string
}
